export default __webpack_public_path__ + "static/media/investment.c4f03877.png";